module.exports = __webpack_public_path__ + "static/img/csmp01.cd95ad8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/upload/csmp01.png
// module id = Splj
// module chunks = 1